import { parse } from 'date-fns'
import { IResponse } from '../request/columnsResponse'

export default function(response: IResponse): Date[] {
  return response.items.map(item => parse(item.marked_day))
}
